/**
 * اسمُ المحلّ في مكانٍ واحد. لا يُكتب أيٌّ منهما حرفيًّا في أيّ مكوّن —
 * فيومَ يتغيّر شيءٌ منه يتغيّر هنا وحده.
 *
 * العربيّ هو الاسمُ الأوّل (الواجهة عربيّةٌ RTL)، والإنجليزيّ يظهر معه
 * حيث يفيد التعرّف: الترويسة، عنوانُ التبويب، والفاتورة لاحقًا.
 */
export const BRAND = {
  /** الاسم المعروض للموظّف والزبون. */
  nameAr: 'عال العال للموبايل',
  /** الاسم اللاتينيّ — يطابق النطاق. */
  nameEn: 'Aqaba Mobile',
  /** المُعرِّف التقنيّ: النطاق وصور Docker والمستودع. */
  slug: 'aqabamobile',
  domain: 'aqabamobile.com',
} as const

/** «عال العال للموبايل · Aqaba Mobile» — للعناوين والترويسات الرسميّة. */
export const brandFull = `${BRAND.nameAr} · ${BRAND.nameEn}`
